import { UserBehaviorRisksAppWebComponent } from './component/UserBehaviorRisksAppWebComponent';
import { WEB_COMPONENT_USER_BEHAVIOR_RISKS_APP } from '../../webcomponents.constants';

export { UserBehaviorRisksAppWebComponent };

window.customElements.define(WEB_COMPONENT_USER_BEHAVIOR_RISKS_APP, UserBehaviorRisksAppWebComponent);
